export default "__VITE_ASSET__bfe470c0__"